import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToDescription'
})
export class EnumToDescriptionPipe implements PipeTransform {

  transform(value: any): any {
    return value.replaceAll('_', ' ');
  }

}
